"use client"

import { Button } from '../../../shared/components/ui/button'
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../shared/components/ui/dialog'
import { SlidersHorizontal } from 'lucide-react'
import React, { useState } from 'react'
import WorkOrdersFilterForm from './forms/work-orders-filter-form'
import { useIsMobile } from '../../../shared/hooks/use-mobile'

interface WorkOrdersFilterButtonProps {
    variant?: "default" | "secondary" | "ghost"
    size?: "default" | "sm" | "lg" | "icon"
    className?: string
    showLabel?: boolean
}

function WorkOrdersFilterButton({ 
    variant = "default", 
    size = "sm",
    className = "",
    showLabel = true 
}: WorkOrdersFilterButtonProps) {
    const [isOpen, setIsOpen] = useState(false)
    const isMobile = useIsMobile()

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button 
                    variant={variant} 
                    size={size} 
                    className={`bg-primary hover:bg-primary/90 text-white font-bold rounded-md gap-2 py-1 h-10 ${className}`}
                >
                    <SlidersHorizontal className="w-5 h-5" />
                    {showLabel !== false && !isMobile && <span>Filter</span>}
                </Button>
            </DialogTrigger>
            <DialogContent className="max-h-[90vh] max-w-4xl">
                <DialogTitle>Filter Work Orders</DialogTitle>
                <div className="overflow-y-auto max-h-[calc(90vh-120px)] pr-4">
                    <WorkOrdersFilterForm onSuccessCallback={() => setIsOpen(false)} />
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default WorkOrdersFilterButton

